module.exports = __webpack_public_path__ + "media/8.f58895ec.mp3";